import { Permission } from '../../types/permissions';

function addPermission(selectedIds: number[], permissionId: number): number[] {
  if (!selectedIds.includes(permissionId)) {
    return [...selectedIds, permissionId];
  }
  return selectedIds;
}

function removePermission(selectedIds: number[], permissionId: number): number[] {
  return selectedIds.filter(id => id !== permissionId);
}

export const permissionUtils = {
  // Verificar si todos los permisos están seleccionados
  areAllPermissionsSelected: (permissions: Permission[], selectedIds: number[]): boolean => {
    return permissions.length > 0 && permissions.every(permission => selectedIds.includes(permission.id));
  },

  // Obtener IDs de permisos
  getPermissionIds: (permissions: Permission[]): number[] => {
    return permissions.map(permission => permission.id);
  },

  // Toggle de permiso
  togglePermission: (selectedIds: number[], permissionId: number, checked: boolean): number[] => {
    return checked
      ? addPermission(selectedIds, permissionId)
      : removePermission(selectedIds, permissionId);
  }
};
